import React from 'react';
import TypedList from './TypedList';

const OPTIONS = [
  { value: 'total-amount', label: 'Total Amount' },
  { value: 'credit-cards', label: 'Credit Cards' },
  { value: 'securities-backed-loan', label: 'Securities Backed Loan' },
  { value: 'line-of-credit', label: 'Line Of Credit' },
  { value: 'personal-note', label: 'Personal Note' },
  { value: 'taxes-owed', label: 'Taxes Owed' },
  { value: 'margin', label: 'Margin' },
  { value: 'education', label: 'Education' },
  { value: 'other', label: 'Other' },
];

export default function LiabilitiesStep({ formData, updateFormData }) {
  return (
    <div data-testid="liabilities-step">
      <h2 className="text-2xl font-bold text-[#0f172a] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Liabilities
      </h2>
      <p className="text-sm text-[#64748b] mb-6">List all outstanding debts, loans, and obligations.</p>
      <TypedList
        title="Liabilities"
        items={formData.liabilities}
        onChange={(v) => updateFormData({ ...formData, liabilities: v })}
        typeOptions={OPTIONS}
        amountLabel="Balance Owed"
        itemLabel="Liability"
        testIdPrefix="liability"
      />
    </div>
  );
}
